import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=10fd5e16&"
import script from "./Configurator.vue?vue&type=script&lang=js&"
export * from "./Configurator.vue?vue&type=script&lang=js&"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=10fd5e16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports